import { Button, Col, Flex, Form, Grid, Row, Select, theme } from 'antd'
import React from 'react'
import { FilterOutlined, HomeOutlined, DeleteOutlined, EyeOutlined, LeftOutlined, SettingOutlined, RightOutlined } from '@ant-design/icons';

const { useBreakpoint } = Grid;

export default function TimeSetting() {
  const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
  const screens = useBreakpoint();
  return (
    <>
      <div style={{
        margin: '16px',
        padding: '8px 12px',
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
      }}>
        <Flex justify='flex-start' align='center' gap={16}>
          <Button type="text" icon={<LeftOutlined />} />
          <span>Time Settings</span>
        </Flex>
      </div>
      <div style={{
        margin: '16px',
        padding: '24px 12px',
        minHeight: '70svh',
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
      }}>
        <Row>
          <Col offset={( screens.xl || screens.xxl) ? 6 : (screens.md || screens.lg) ? 2 : 0} xxl={12} xl={12} lg={20} md={20} sm={24} xs={24}>
            <Form layout='vertical'>
              <Form.Item label="Country" name="layout">
                <Select
                  showSearch
                  placeholder="Select a Country"
                  optionFilterProp="label"
                  options={[
                    {
                      value: '+5.30',
                      label: '+5.30',
                    },
                    {
                      value: '+6.30',
                      label: '+6.30',
                    },
                    {
                      value: '+7.30',
                      label: '+7.30',
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item label="Time Zone" name="layout">
                <Select
                  showSearch
                  placeholder="Select a TimeZone"
                  optionFilterProp="label"
                  options={[
                    {
                      value: '+5.30',
                      label: '+5.30',
                    },
                    {
                      value: '+6.30',
                      label: '+6.30',
                    },
                    {
                      value: '+7.30',
                      label: '+7.30',
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item label="Country" name="layout">
                <Select
                  showSearch
                  placeholder="Select a Country"
                  optionFilterProp="label"
                  options={[
                    {
                      value: '+5.30',
                      label: '+5.30',
                    },
                    {
                      value: '+6.30',
                      label: '+6.30',
                    },
                    {
                      value: '+7.30',
                      label: '+7.30',
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item label="Time Zone" name="layout">
                <Select
                  showSearch
                  placeholder="Select a TimeZone"
                  optionFilterProp="label"
                  options={[
                    {
                      value: '+5.30',
                      label: '+5.30',
                    },
                    {
                      value: '+6.30',
                      label: '+6.30',
                    },
                    {
                      value: '+7.30',
                      label: '+7.30',
                    },
                  ]}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
        <Row>
        <Col offset={( screens.xl || screens.xxl) ? 6 : (screens.md || screens.lg) ? 2 : 0} xxl={12} xl={12} lg={20} md={20} sm={24} xs={24}>
            <Flex justify='flex-end' align='center' gap='large'>
              <Button type='Default'>
                Reset
              </Button>
              <Button type='primary'>
                Save
              </Button>
            </Flex>
          </Col>
        </Row>
      </div>

    </>
  )
}
